const launchButtons = document.querySelectorAll('.open-kodif-chat');
  const openKodifChat = () => {
    const iframe = document.getElementById('kodif-chat-widget');
    if (iframe) {
      iframe.contentWindow.postMessage({ type: 'toggle-expanded', isExpanded: true }, '*');
      return true;
    }
    return false;
  };
  launchButtons.forEach(button => {
    button.addEventListener('click', () => {
      if (!openKodifChat()) {
        console.warn("Iframe not ready yet. Waiting...");
      }
    });
  });
  const observer = new MutationObserver(() => {
    const iframe = document.getElementById('kodif-chat-widget');
    if (iframe) {
      console.log("Kodif iframe detected!");
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });